import React from "react";

const AdmissionNotice = () => {
  return (
    <div
      className="gdlr-core-pbf-column gdlr-core-column-30 gdlr-core-column-first"
    >
      <div className="gdlr-core-pbf-column-content-margin gdlr-core-js" style={{ padding: "45px 0px 0px 0px" }}>
        <div className="gdlr-core-pbf-column-content clearfix gdlr-core-js">
          {/* Notice Text */}
          <div className="gdlr-core-pbf-element">
            <div
              className="gdlr-core-text-box-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align"
              style={{ paddingBottom: "20px" }}
            >
              <div
                className="gdlr-core-text-box-item-content"
                style={{ fontSize: "23px", textTransform: "none", color: "#ffffff" }}
              >
                <p>
                  Admissions for the Academic Year 2025 will start now. The
                  admission starts for DGNM (General Nursing & Midwifery Course )
                  Three years
                </p>
              </div>
            </div>
          </div>

          {/* Buttons */}
          <div className="gdlr-core-pbf-element">
            <div className="gdlr-core-button-item gdlr-core-item-pdlr gdlr-core-left-align">
              <a
                className="gdlr-core-button gdlr-core-button-solid gdlr-core-button-no-border"
                href="#"
                style={{
                  fontSize: "14px",
                  fontWeight: "700",
                  letterSpacing: "0px",
                  padding: "13px 26px 16px 30px",
                  textTransform: "none",
                  margin: "0px 10px 10px 0px",
                  borderRadius: "2px",
                  background: "#ffcb05",
                  color: "#7c1c1b",
                }}
              >
                <span className="gdlr-core-content">Apply</span>
                <i
                  className="gdlr-core-pos-right fa fa-external-link"
                  style={{ fontSize: "14px" }}
                ></i>
              </a>
              <a
                className="gdlr-core-button gdlr-core-button-solid gdlr-core-button-no-border"
                href="#"
                style={{
                  fontSize: "14px",
                  fontWeight: "700",
                  letterSpacing: "0px",
                  padding: "13px 26px 16px 30px",
                  textTransform: "none",
                  borderRadius: "2px",
                  background: "#ffcb05",
                  color: "#7c1c1b",
                }}
              >
                <span className="gdlr-core-content">Download Brochure</span>
                <i
                  className="gdlr-core-pos-right fa fa-file-pdf-o"
                  style={{ fontSize: "14px" }}
                ></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdmissionNotice;
